import React from 'react'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'
import { withRouter } from 'react-router-dom'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'

import ContextActionsSelect from 'components/ContextActionsSelect/ContextActionsSelect'
import ExternalNavigation from 'components/Navigation/ExternalNavigation/ExternalNavigation'

import './app-header-mobile-vertical-nav.pcss'

const AppHeaderMobileVerticalNav = ({ t }) => {
    return (
        <ContextActionsSelect
            cssClass="app-header-mobile-vertical-nav"
            renderCustomButton={() => null}
            renderChevron
            chevronProps={{ size: 's' }}
        >
            <ul>
                <ExternalNavigation />
            </ul>
        </ContextActionsSelect>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
    withTranslationCustom(),
)(AppHeaderMobileVerticalNav)
